import SidebarIconUsers from "./SidebarIconUsers";
import SidebarIconClipboardList from "./SidebarIconClipboardList";
import SidebarIconSettings from "./SidebarIconSettings";
import SidebarIconChartBar from "./SidebarIconChartBar";
import SidebarIconBuilding from "./SidebarIconBuilding";
import SidebarIconPanelLeft from "./SidebarIconPanelLeft";
import SidebarIconRoute from "./SidebarIconRoute";
import SidebarIconFile from "./SidebarIconFile";
import SidebarIconPlus from "./SidebarIconPlus";

export const SIDEBAR_NAV_ICON_COMPONENTS = {
  users: SidebarIconUsers,
  "clipboard-list": SidebarIconClipboardList,
  settings: SidebarIconSettings,
  "chart-bar": SidebarIconChartBar,
  building: SidebarIconBuilding,
  route: SidebarIconRoute,
  file: SidebarIconFile,
  plus: SidebarIconPlus
};

export {
  SidebarIconUsers,
  SidebarIconClipboardList,
  SidebarIconSettings,
  SidebarIconChartBar,
  SidebarIconBuilding,
  SidebarIconPanelLeft,
  SidebarIconRoute,
  SidebarIconFile,
  SidebarIconPlus
};
